import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from './Container';
import logo from '../../../assets/askneo-favicon.png';

const FooterV2 = ({ variant = 'dark' }) => {
  const isDark = variant === 'dark';
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: isDark
          ? (theme) => theme.palette.v2.surface.band
          : 'background.default',
        color: isDark ? '#FFFFFF' : 'text.primary',
        py: { xs: 5, md: 6 },
        borderTop: (theme) => `1px solid ${
          isDark ? theme.palette.v2.surface.divider : theme.palette.v2.neutral[200]
        }`
      }}
    >
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            gap: 3
          }}
        >
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25 }}>
            <Box
              component="img"
              src={logo}
              alt=""
              sx={{ height: 32, width: 32, display: 'block', borderRadius: '50%' }}
            />
            <Box component="span" sx={{ fontWeight: 700, fontSize: '1rem', letterSpacing: '-0.01em', color: 'inherit' }}>
              AskNeo
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: { xs: 2, md: 4 }, flexWrap: 'wrap' }}>
            <Box
              component="a"
              href="https://askneo.io/terms"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'inherit',
                opacity: 0.8,
                fontSize: '0.9375rem',
                textDecoration: 'none',
                '&:hover': { opacity: 1, textDecoration: 'underline' }
              }}
            >
              Terms &amp; Conditions
            </Box>
            <Box
              component="a"
              href="https://askneo.io/privacy"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'inherit',
                opacity: 0.8,
                fontSize: '0.9375rem',
                textDecoration: 'none',
                '&:hover': { opacity: 1, textDecoration: 'underline' }
              }}
            >
              Privacy Policy
            </Box>
          </Box>
          <Typography
            variant="body2"
            sx={{ opacity: 0.7, fontSize: '0.875rem' }}
          >
            © {year} AskNeo. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterV2;
